import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../services/common/common.service';
import { CompanyService } from '../../../../../services/company/company.service';
import { AuthService } from '../../../../../services/auth.service';
import { FieldMappingService } from '../../../../../services/field-mapping/field-mapping.service';

@Component({
  selector: 'app-staging-audit',
  templateUrl: './staging-audit.component.html',
  styleUrl: './staging-audit.component.scss',
})
export class StagingAuditComponent implements OnInit {
  filterForm!: FormGroup;

  listData: any[] = [];
  loading = false;
  totalRecords = 0;
  page = 1;
  pageSize = 50;
  pageSizeOptions = [10, 25, 50, 100];

  companyList: any[] = [];
  dateFormat = 'dd/mm/yyyy';
  angularDateFormat = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly fieldMappingService: FieldMappingService,
    private readonly companyService: CompanyService,
    private readonly commonService: CommonService,
    private readonly auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadCompanies();
    this.setupDateFormat();
  }

  private initForm(): void {
    this.filterForm = this.fb.group({
      company_id: [null],
      employee_id: [''],
      from_date: [null],
      to_date: [null],
    });
  }

  private loadCompanies(): void {
    this.companyService.getClientCompanyList().subscribe({
      next: (resp: any) => {
        this.companyList = resp?.data || [];
      },
      error: () => {},
    });
  }

  private setupDateFormat(): void {
    const userData: any = this.commonService.getLocalStorageData();
    if (userData?.companyID) {
      this.companyService.getParametersById(userData.companyID).subscribe({
        next: (resp: any) => {
          if (resp?.data?.date_format) {
            const fmt = resp.data.date_format;
            this.dateFormat = fmt.replace('mm', 'MM');
            this.angularDateFormat =
              this.commonService.convertPrimeNGToAngularFormat(fmt);
          }
        },
      });
    }
  }

  search(): void {
    this.page = 1;
    this.loadData();
  }

  reset(): void {
    this.filterForm.reset();
    this.listData = [];
    this.totalRecords = 0;
  }

  handlePageChange(newPage: number): void {
    this.page = newPage > 0 ? newPage : 1;
    this.loadData();
  }

  handlePageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.page = 1;
    this.loadData();
  }

  private loadData(): void {
    const { company_id, employee_id, from_date, to_date } =
      this.filterForm.value;

    const params: any = { page: this.page, limit: this.pageSize };
    if (company_id) params['company_id'] = company_id;
    if (employee_id?.trim()) params['employee_id'] = employee_id.trim();
    if (from_date) params['from_date'] = this.toISODate(from_date);
    if (to_date) params['to_date'] = this.toISODate(to_date);

    this.loading = true;
    this.fieldMappingService.getStagingAudit(params).subscribe({
      next: (resp: any) => {
        this.listData = resp?.data || [];
        this.totalRecords = resp?.pagination?.total || 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  private toISODate(value: any): string {
    if (!value) return '';
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    return String(value);
  }

  directionLabel(dir: string): string {
    if (dir === 'I') return 'IN';
    if (dir === 'O') return 'OUT';
    return 'N/A';
  }

  directionClass(dir: string): string {
    if (dir === 'I') return 'badge bg-success';
    if (dir === 'O') return 'badge bg-danger';
    return 'badge bg-secondary';
  }

  checkPermission(type: string): boolean {
    return this.auth.checkPermission(type);
  }
}
